export const branchConstants = {
    BRANCH_FETCHING: 'BRANCH_FETCHING',
    BRANCH_FETCHED: 'BRANCH_FETCHED',
    BRANCH_SUBMITTING: 'BRANCH_SUBMITTING',
    BRANCH_SUBMITTED: 'BRANCH_SUBMITTED',
    GET_BRANCHES: 'GET_BRANCHES',
    GET_BRANCH_BY_ID: 'GET_BRANCH_BY_ID',
    GET_ACTIVE_BRANCHES: 'GET_ACTIVE_BRANCHES',
    GET_BRANCH_FROM_BASE: 'GET_BRANCH_FROM_BASE',
}